export default __webpack_public_path__ + "static/media/v14.d0ad6e88.svg";